import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ButtonBaseComponent } from './button-base.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { DropdownPanelScope, PanelTriggerDirective } from '@sb/library/base';

@Component({
    selector: 'lib-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent extends ButtonBaseComponent implements OnInit, DropdownPanelScope {

    Scope = this.SetScope({
        Implements: DropdownPanelScope
    });

    @ViewChild (PanelTriggerDirective, { static: false }) panelContainer!: PanelTriggerDirective;

    @ViewChild('label', {static: false}) buttonLabel: ElementRef<HTMLElement> | undefined;

    @ViewChild(IconButtonComponent, { static: false }) private iconButtonRef: IconButtonComponent | undefined;

    get isLabelTruncated(): boolean {
        const el = this.buttonLabel?.nativeElement;
        return !!el && el.scrollWidth > el.clientWidth;
    }

    // ViewChild(MatMenuTrigger) can't see the trigger nested inside lib-icon-button's own template, so fall back to it when iconOnly
    get menuTriggerRef(): MatMenuTrigger {
        return this.matMenuTrigger ?? this.iconButtonRef?.matMenuTrigger!;
    }

}
